import { useEffect, useState } from "react";
import { Clock } from "lucide-react";

function fmt(n) {
  return n < 10 ? `0${n}` : String(n);
}

function breakdown(ms) {
  if (ms <= 0) return null;
  const totalSec = Math.floor(ms / 1000);
  const days = Math.floor(totalSec / 86400);
  const hours = Math.floor((totalSec % 86400) / 3600);
  const minutes = Math.floor((totalSec % 3600) / 60);
  const seconds = totalSec % 60;
  return { days, hours, minutes, seconds };
}

/** Tight countdown ticker. Goes LIVE at t=0, then shows a pulsing "LIVE" dot. */
export default function Countdown({ startIso, testId }) {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, []);

  if (!startIso) return null;
  const start = Date.parse(startIso);
  if (Number.isNaN(start)) return null;
  const diff = start - now;
  const b = breakdown(diff);

  if (!b) {
    return (
      <div
        className="flex items-center gap-2 mono text-[11px] text-red-400 uppercase tracking-widest"
        data-testid={testId}
      >
        <span className="w-2 h-2 rounded-full bg-red-400 animate-pulse" /> LIVE · FIRST
        PITCH
      </div>
    );
  }

  return (
    <div
      className="flex items-center gap-2 mono text-[11px] text-zinc-400 uppercase tracking-widest"
      data-testid={testId}
    >
      <Clock size={12} strokeWidth={1.5} />
      <span className="text-zinc-500">GAME 1 IN</span>
      <span className="neon-text">
        {b.days > 0 && `${b.days}d `}
        {fmt(b.hours)}:{fmt(b.minutes)}:{fmt(b.seconds)}
      </span>
    </div>
  );
}
